import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e81e58ac&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e81e58ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81e58ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81e58ac')) {
      api.createRecord('e81e58ac', component.options)
    } else {
      api.reload('e81e58ac', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e81e58ac&scoped=true&", function () {
      api.rerender('e81e58ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23m9Z44veXyd5/JS/comp/GuestBox.vue"
export default component.exports